// import React, { useEffect, useState } from "react";
// import { Table, Modal, Button, Pagination, Row, Col } from "react-bootstrap";
// import { FaInfoCircle } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL || 'https://api.shubhbhoomirealestate.com/adminapi';

// function AllNotificationList() {
//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [notificationToDelete, setNotificationToDelete] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [notificationsPerPage] = useState(10);

//   const [showModal, setShowModal] = useState(false); // for remark modal
//   const [selectedRemark, setSelectedRemark] = useState(""); // selected remark

//   useEffect(() => {
//     fetchNotifications();
//   }, []);

//   const fetchNotifications = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const response = await fetch(`${API_URL}/notification-data`, {
//         headers: { 'Authorization': `Bearer ${token}` }
//       });
//       const data = await response.json();
//       if (data.status === "1") setNotifications(data.data || []);
//       else setNotifications([]);
//     } catch (err) {
//       setError(err.message);
//       setNotifications([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleShowModal = (remark) => {
//     setSelectedRemark(remark);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedRemark("");
//   };

//   // Pagination
//   const indexOfLast = currentPage * notificationsPerPage;
//   const indexOfFirst = indexOfLast - notificationsPerPage;
//   const currentNotifications = notifications.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.ceil(notifications.length / notificationsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div className="alert alert-danger">{error}</div>;

//   return (
//     <div className="userlist mt-2">
//       <div className="card">
//         <div className="card-header d-flex justify-content-between align-items-center">
//           <h4>All Notifications</h4>
//         </div>

//         <div className="card-body">
//           {notifications.length === 0 ? (
//             <div className="text-center p-5">
//               <p>No notifications found. Click "Add Notification" to create one.</p>
//             </div>
//           ) : (
//             <>
//               <div className="table-responsive">
//                 <Table striped bordered hover>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>Lead ID</th>
//                       <th>Type</th>
//                       <th>Message</th>
//                       <th>Remark</th>
//                       <th>Status</th>
//                       <th>Action BY</th>
//                       <th>Date Time</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentNotifications.map((notification, index) => (
//                       <tr key={notification.id}>
//                         <td>{indexOfFirst + index + 1}</td>
//                         <td>{notification.order_id}</td>
//                         <td>
//                           {notification.type
//                             .replace(/_/g, " ") // underscores को space में बदलना
//                             .replace(/\b\w/g, (char) => char.toUpperCase())} {/* हर शब्द का पहला अक्षर capital */}
//                         </td>


//                         <td>{notification.message?.substring(0, 50)}...</td>
//                         <td style={{ wordBreak: "break-word" }}>
//                           {notification.remark?.substring(0, 30)}{" "}
//                           {notification.remark?.length > 30 && (
//                             <Button
//                               variant="link"
//                               size="sm"
//                               style={{ padding: 0 }}
//                               onClick={() => handleShowModal(notification.remark)}
//                             >
//                               <FaInfoCircle color="blue" />
//                             </Button>
//                           )}
//                         </td>
//                         <td className={notification.statusremark === 'approved' ? 'text-success' : ''}>{notification.statusremark.charAt(0).toUpperCase() + notification.statusremark.slice(1).toLowerCase()}</td>
//                         <td> {notification.action_by.charAt(0).toUpperCase() + notification.action_by.slice(1).toLowerCase()}</td>
//                         <td>
//                           {(() => {
//                             const date = new Date(notification.date_time.replace(" ", "T"));
//                             return (
//                               date.toLocaleDateString("en-GB") +
//                               " " +
//                               date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
//                             );
//                           })()}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>

//               {totalPages > 1 && (
//                 <Row className="mt-3">
//                   <Col>
//                     <Pagination>
//                       <Pagination.First onClick={() => paginate(1)} disabled={currentPage === 1} />
//                       <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
//                       {[...Array(totalPages).keys()].map(number => (
//                         <Pagination.Item
//                           key={number + 1}
//                           active={number + 1 === currentPage}
//                           onClick={() => paginate(number + 1)}
//                         >
//                           {number + 1}
//                         </Pagination.Item>
//                       ))}
//                       <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
//                       <Pagination.Last onClick={() => paginate(totalPages)} disabled={currentPage === totalPages} />
//                     </Pagination>
//                   </Col>
//                 </Row>
//               )}
//             </>
//           )}
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       <Modal show={showModal} onHide={handleCloseModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Remark Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p style={{ wordBreak: "break-word" }}>{selectedRemark}</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

// export default AllNotificationList;

import React, { useEffect, useState } from "react";
import { Table, Modal, Button, Pagination, Row, Col } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://api.shubhbhoomirealestate.com/adminapi";

function AllNotificationList() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [notificationToDelete, setNotificationToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [notificationsPerPage] = useState(10);

  const [showModal, setShowModal] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/notification-data`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (data.status === "1") setNotifications(data.data || []);
      else setNotifications([]);
    } catch (err) {
      setError(err.message);
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  const handleShowModal = (remark) => {
    setSelectedRemark(remark);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRemark("");
  };

  // Pagination
  const indexOfLast = currentPage * notificationsPerPage;
  const indexOfFirst = indexOfLast - notificationsPerPage;
  const currentNotifications = notifications.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(notifications.length / notificationsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#64748b",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "3px solid #cbd5e1",
              borderTop: "3px solid #2b6cb0",
              borderRadius: "50%",
              display: "inline-block",
              animation: "spin 0.8s linear infinite",
            }}
          />
          <p
            style={{
              marginTop: "16px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            Loading Notifications...
          </p>
        </div>
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              border: "1.5px solid #fecaca",
              padding: "40px 24px",
              textAlign: "center",
              color: "#dc2626",
              fontWeight: "700",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
            }}
          >
            {error}
            <br />
            <button
              onClick={() => fetchNotifications()}
              style={{
                marginTop: "16px",
                padding: "10px 20px",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                color: "#ffffff",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🔔
            </div>
            <div style={{ flex: 1, minWidth: "220px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                All Notifications
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                {notifications.length > 0
                  ? `Total Notifications: ${notifications.length}`
                  : "View all system notifications"}
              </p>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px" }}>
              {notifications.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#dc2626",
                    fontWeight: "700",
                  }}
                >
                  No notifications found.
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <Table bordered hover>
                      <thead
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          color: "#ffffff",
                        }}
                      >
                        <tr>
                          <th>#</th>
                          <th>Lead ID</th>
                          <th>Type</th>
                          <th>Message</th>
                          <th>Remark</th>
                          <th>Status</th>
                          <th>Action BY</th>
                          <th>Date Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentNotifications.map((notification, index) => (
                          <tr key={notification.id}>
                            <td className="fw-bold">
                              {indexOfFirst + index + 1}
                            </td>
                            <td>{notification.order_id}</td>
                            <td>
                              {notification.type
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (char) =>
                                  char.toUpperCase(),
                                )}
                            </td>

                            <td>
                              {notification.message?.substring(0, 50)}...
                            </td>
                            <td style={{ wordBreak: "break-word" }}>
                              {notification.remark?.substring(0, 30)}{" "}
                              {notification.remark?.length > 30 && (
                                <Button
                                  variant="link"
                                  size="sm"
                                  style={{ padding: 0 }}
                                  onClick={() =>
                                    handleShowModal(notification.remark)
                                  }
                                >
                                  <FaInfoCircle color="#2b6cb0" />
                                </Button>
                              )}
                            </td>
                            <td
                              style={{
                                color:
                                  notification.statusremark === "approved"
                                    ? "green"
                                    : "#1e3a5f",
                                fontWeight: 600,
                              }}
                            >
                              {notification.statusremark.charAt(0).toUpperCase() +
                                notification.statusremark.slice(1).toLowerCase()}
                            </td>
                            <td>
                              {" "}
                              {notification.action_by.charAt(0).toUpperCase() +
                                notification.action_by.slice(1).toLowerCase()}
                            </td>
                            <td>
                              {(() => {
                                const date = new Date(
                                  notification.date_time.replace(" ", "T"),
                                );
                                return (
                                  date.toLocaleDateString("en-GB") +
                                  " " +
                                  date.toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })
                                );
                              })()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  {totalPages > 1 && (
                    <div className="d-flex justify-content-end mt-3">
                      <Pagination>
                        <Pagination.First
                          onClick={() => paginate(1)}
                          disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                          onClick={() => paginate(currentPage - 1)}
                          disabled={currentPage === 1}
                        />
                        {[...Array(totalPages).keys()].map((number) => (
                          <Pagination.Item
                            key={number + 1}
                            active={number + 1 === currentPage}
                            onClick={() => paginate(number + 1)}
                          >
                            {number + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() => paginate(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                          onClick={() => paginate(totalPages)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* Remark Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Remark Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ wordBreak: "break-word" }}>{selectedRemark}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default AllNotificationList;
